import { FieldContentNode } from '@helo/cms'
import { startTransition, useState } from 'react'

import { ErrorBoundary } from '../../../components/ErrorBoundary/ErrorBoundary'
import { WidgetError } from '../../../components/Errors/WidgetError'
import { CellRendererProps } from '../table.types'
import { TypeRendererCell } from './TypeRendererCell'

interface CellRendererCompProps extends CellRendererProps {}

/**
 * Compose with cell component to wrap cell with common component.
 *
 * Adds full alignment to every kind of cell, no matter the content type.
 *
 * Usage:
 * ```tsx
 * {
 *  component: CellWrapper(TextCell),
 * }
 * ```
 */
export const CellRenderer = (props: CellRendererCompProps) => {
  const [isCellHover, setIsCellHover] = useState(false)

  const contentNode = props.value as FieldContentNode

  if (!contentNode) {
    throw new Error('Content node not found for column config')
  }

  return (
    <div
      style={{ padding: '12px 0', lineHeight: 1.2, flex: 1 }}
      onMouseEnter={() => startTransition(() => setIsCellHover(true))}
      onMouseLeave={() => startTransition(() => setIsCellHover(false))}
      data-component="CellRenderer"
    >
      <ErrorBoundary
        renderError={error => (
          <WidgetError flexDir="row">{error.message}</WidgetError>
        )}
      >
        <TypeRendererCell
          // overflowWrap="break-word"
          isCellHover={isCellHover}
          {...props}
          // colDef={{ ...colDef, options: mappedOptions }}
          contentNode={contentNode as any}
        />
      </ErrorBoundary>
    </div>
  )
}
